import handleFetchErrors from '../utils/handleFetchErrors';
import { getAccessTokenFromLocalStorage } from '../utils/authHelpers';

const BASE_URL = process.env.REACT_APP_SEARCH360_HOST;

export function getRecommendNavFilter() {
  return async ({ queryKey }: { queryKey: string[] }): Promise<RecNav> => {
    const [uri, query, body] = queryKey;
    const url = `${BASE_URL}${uri}?${query}`;
    return fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
        'Content-Type': 'application/json',
      },
      body,
    })
      .then(handleFetchErrors)
      .then((res) => res.json());
  };
}
